import App from './App.svelte';
import 'intersection-observer';

const app = new App({
  target: document.getElementById('root'),
  props: {
    doc: '17TVRRBJfySU_hklpmcjeK-Ud6fM0Ncwcebfl8pUbEfk',
    assetHost: window.location.hostname === 'www.thenewslens.com' ? 'https://activity.thenewslens.com/career-choices/' : ''
  },
});

export default app;
